(function() {
  "use strict";

  const $btnToggleBusca = $(".header-busca-btn");
  const $btnToggleBuscaWrap = $(".header-busca");
  const $buscaWrap = $(".header-busca-wrap");
  const $buscaInput = $buscaWrap.find("input");

  $btnToggleBusca.on("click", function(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    if ($btnToggleBuscaWrap.hasClass("open")) {
      hideBusca();
    } else {
      showBusca();
    }
  });
  $buscaWrap.on("click", function(ev) {
    ev.stopPropagation();
  });

  $("body").on("click", function(ev) {
    hideBusca();
  });

  function showBusca() {
    $btnToggleBuscaWrap.addClass("open");
    $buscaWrap.addClass("open");
    $buscaInput.focus();
  }

  function hideBusca() {
    $btnToggleBuscaWrap.removeClass("open");
    $buscaWrap.removeClass("open");
    $buscaInput.val("");
  }
})();
